export default __webpack_public_path__ + "static/UniGraz_Logo_medium-c53df0ec0a5a6acee79f0744c2a8934a.png";